import { PayloadAction } from '@reduxjs/toolkit'
import {
  IAiAvatarState,
  IAvatarData,
  IAvatarGenerationParams,
  IAvatarGiftAccess,
  IPublicAvatar
} from 'store/types/aiAvatar'
import { IAvatarModels } from 'types/avatar'
import { avatarGenerationInitialParams } from './initialState'

const reducers = {
  setIsLoadingTabData: (
    state: IAiAvatarState,
    action: PayloadAction<boolean>
  ) => {
    state.isLoadingTabData = action.payload
  },
  setAvatar: (
    state: IAiAvatarState,
    action: PayloadAction<IAvatarData | null>
  ) => {
    state.generationParams.avatar = action.payload
  },
  updateAvatar: (
    state: IAiAvatarState,
    action: PayloadAction<Partial<IAvatarData>>
  ) => {
    if (!state.generationParams.avatar) return
    state.generationParams.avatar = {
      ...state.generationParams.avatar,
      ...action.payload
    }
  },
  setAvatarLoading: (state: IAiAvatarState, action: PayloadAction<boolean>) => {
    state.isAvatarLoading = action.payload
  },
  clearAvatar: (state: IAiAvatarState) => {
    state.generationParams.avatar = null
    // The aspect-ratio switcher lives only in the public-avatars panel, so
    // removing the avatar drops its override too — the next avatar (upload /
    // media library / another public one) starts from the project ratio.
    state.generationParams.aspectRatio = null
    state.isAvatarLoading = false
  },
  setVoiceLangCode: (state: IAiAvatarState, action: PayloadAction<string>) => {
    state.generationParams.voice.langCode = action.payload
  },
  setVoiceSpeakerId: (state: IAiAvatarState, action: PayloadAction<number>) => {
    state.generationParams.voice.speakerId = action.payload
  },
  setVoiceSpeed: (state: IAiAvatarState, action: PayloadAction<number>) => {
    state.generationParams.voice.speed = action.payload
  },
  setQuality: (state: IAiAvatarState, action: PayloadAction<number>) => {
    state.generationParams.quality = action.payload
  },
  setSpeechText: (state: IAiAvatarState, action: PayloadAction<string>) => {
    state.generationParams.speechText = action.payload
  },
  setAvatarAspectRatio: (
    state: IAiAvatarState,
    action: PayloadAction<string | null>
  ) => {
    state.generationParams.aspectRatio = action.payload
  },
  setPublicAvatars: (
    state: IAiAvatarState,
    action: PayloadAction<IPublicAvatar[]>
  ) => {
    state.publicAvatars.data = action.payload
  },
  setPublicAvatarsLoading: (
    state: IAiAvatarState,
    action: PayloadAction<boolean>
  ) => {
    state.publicAvatars.isLoading = action.payload
  },
  setAvatarModels: (
    state: IAiAvatarState,
    action: PayloadAction<IAvatarModels[]>
  ) => {
    state.avatarModels.data = action.payload
  },
  setAvatarModelsLoading: (
    state: IAiAvatarState,
    action: PayloadAction<boolean>
  ) => {
    state.avatarModels.isLoading = action.payload
  },
  setGiftAccess: (
    state: IAiAvatarState,
    action: PayloadAction<IAvatarGiftAccess | null>
  ) => {
    state.giftAccess.data = action.payload
  },
  setGiftAccessLoading: (
    state: IAiAvatarState,
    action: PayloadAction<boolean>
  ) => {
    state.giftAccess.isLoading = action.payload
  },
  setIsGenerating: (state: IAiAvatarState, action: PayloadAction<boolean>) => {
    state.isGenerating = action.payload
  },
  setAwaitingGiftRecheck: (
    state: IAiAvatarState,
    action: PayloadAction<boolean>
  ) => {
    state.isAwaitingGiftRecheck = action.payload
  },
  setGenerationParams: (
    state: IAiAvatarState,
    action: PayloadAction<IAvatarGenerationParams>
  ) => {
    state.generationParams = action.payload
  },
  resetGenerationParams: (state: IAiAvatarState) => {
    state.generationParams = avatarGenerationInitialParams
  }
}

export default reducers
